import React, { Component } from "react";
import { Row, Col } from "antd";
import sdgood from "../../assets/banner/sandee_good.png";
import "./wk.style.css";
export default class walkinlogo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="wk-mascot-section">
        <Row className="wk-mascot-wrapper" style={{ display: "flex", alignItems: "center" }}>
          <Col
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <div className="wk-mascot-background"></div>
            <img src={sdgood} alt="SANDEE Mascot" className="wk-mascot-image" />
          </Col>
          <Col
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <div >
              <h1 className="wk-main-title">SANDEE Chatbot</h1>
              <h2 className="wk-sub-title">Open Ticket | Walk-in Center</h2>
            </div>

          </Col>
        </Row>
      </div>
    );
  }
}
